import React from 'react';
import {
  Box,
  Paper,
  Typography,
  CircularProgress,
  LinearProgress,
  Snackbar,
  Alert,
  AlertTitle,
  Backdrop
} from '@mui/material';

const ProgressFeedback = ({ 
  isLoading, 
  progress, 
  alert, 
  onCloseAlert,
  loadingMessage = "Procesando..."
}) => (
  <>
    {/* Loading Overlay */}
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: 9999,
        backgroundColor: 'rgba(0,0,0,0.7)'
      }}
      open={isLoading}
    >
      <Paper 
        elevation={8}
        sx={{ 
          p: 4, 
          textAlign: 'center', 
          maxWidth: 400,
          borderRadius: 3,
          backgroundColor: 'white'
        }}
      >
        <CircularProgress 
          sx={{ 
            color: '#4DABA4', 
            mb: 2,
            size: 60
          }} 
          size={60}
        />
        <Typography 
          variant="h6" 
          sx={{ 
            mb: 2,
            color: '#333',
            fontWeight: 600
          }}
        >
          {loadingMessage}
        </Typography>
        
        {/* Progress Bar */}
        <Box sx={{ width: '100%', mb: 1 }}>
          <LinearProgress 
            variant="determinate" 
            value={progress || 0} 
            sx={{ 
              height: 8, 
              borderRadius: 4,
              backgroundColor: '#e0e0e0',
              '& .MuiLinearProgress-bar': { 
                backgroundColor: '#4DABA4',
                borderRadius: 4
              }
            }}
          />
        </Box>
        
        <Typography 
          variant="body2" 
          color="text.secondary" 
          sx={{ mt: 1 }}
        >
          {progress || 0}% completado
        </Typography>
      </Paper>
    </Backdrop>
    
    {/* Success/Error Alerts */}
    <Snackbar 
      open={alert?.open || false} 
      autoHideDuration={6000}
      onClose={onCloseAlert}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert 
        severity={alert?.type || 'info'} 
        onClose={onCloseAlert}
        sx={{ 
          width: '100%',
          '& .MuiAlert-icon': {
            fontSize: '1.5rem'
          }
        }}
        elevation={6}
        variant="filled"
      >
        <AlertTitle sx={{ fontWeight: 600 }}>
          {alert?.type === 'success' ? '¡Éxito!' : 
           alert?.type === 'error' ? 'Error' : 
           alert?.type === 'warning' ? 'Atención' : 'Información'}
        </AlertTitle>
        {alert?.message}
      </Alert>
    </Snackbar>
  </>
);

export default ProgressFeedback; 